import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// SEO fallback is now hidden via CSS by default — no JS toggle needed

createRoot(document.getElementById("root")!).render(<App />);

// Defer Sentry to after first paint - not needed for initial render
if (typeof requestIdleCallback === "function") {
  requestIdleCallback(() => import("./lib/sentry").then(m => m.initSentry()));
} else {
  setTimeout(() => import("./lib/sentry").then(m => m.initSentry()), 2000);
}
